import React, { useState,useEffect } from "react"; 
import { useNotification } from "../../NotificationContext";
import { Supplier, SupplierErrors } from "../../interfaces/Supplier";
import { createSupplier, updateSupplier } from "../../apis/Supplier";
import { Select } from "antd";

type AddSupplierProps = {
  closeModal: () => void;
  editableId?: number | null;
  supplierData?: any;
};

const AddSupplier: React.FC<AddSupplierProps> = ({ 
  closeModal,
  editableId,
  supplierData, 
}) => {
  const defaultSupplier: Supplier = {
    name: "",
    contactPerson: "",
    phone: "",
    email:"",
    pan:"",
    gst: "",
    address: "",
    status: "Active",
  };

  const [supplier, setSupplier] = useState<Supplier>(defaultSupplier);
  const [errors, setErrors] = useState<SupplierErrors>({});
  const { showNotification } = useNotification();
  const isEditMode = Boolean(editableId);
 const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editableId && supplierData) {
      setSupplier(supplierData);
    } else {
      setSupplier(defaultSupplier);
    }
  }, [editableId, supplierData]);

  const validateForm = () => {
    const e: SupplierErrors = {};
    if (supplier.name.length === 0) e.name = "* Name is required";
    if (!supplier.contactPerson) e.contactPerson = "* Contact is required";
    if (!supplier.phone) {
      e.phone = "* Phone is required";
    } else if (!/^\d{10}$/.test(supplier.phone)) {
      e.phone = "* Phone must be 10 digits";
    }
    // if (!supplier.email) {
    //   e.email = "* Email is required";
    // } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(supplier.email)) {
    //   e.email = "* Enter a valid email";
    // }
    
    return { hasErrors: Object.keys(e).length > 0, errors: e };
  };

const onSave = async () => {
  const { hasErrors, errors } = validateForm();
  if (hasErrors) {
    setErrors(errors);
    return;
  }

  setLoading(true);
  try {
    if (isEditMode) {
      await updateSupplier(editableId!, supplier);
      showNotification("success", "Supplier updated successfully", "", "topRight");
    } else {
      await createSupplier(supplier);
      showNotification("success", "Supplier created successfully", "", "topRight");
    }
    closeModal();
  } catch (err: any) {
    showNotification(
      "error",
      err.response?.data?.message || "Error saving supplier",
      "",
      "topRight"
    );
  } finally {
    setLoading(false);
  }
};

  return (
    <div>
      <div className="pt-2">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          Name
        </label>
        <div className="mt-1">
          <input
            type="text"
            value={supplier.name}
            onChange={(e) => setSupplier({ ...supplier, name: e.target.value })}
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        </div>

        {errors.name && (
          <span className="text-sm text-red-500 leading-0">{errors.name}</span>
        )}
      </div>

      <div className="flex gap-4 pt-2">
        <div className="flex-1">
          <label className="block text-sm font-medium leading-6 text-gray-900">
            Contact Name
          </label>
          <div className="mt-1">
            <input
              type="text"
              value={supplier.contactPerson}
              onChange={(e) =>
                setSupplier({ ...supplier, contactPerson: e.target.value })
              }
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 
                   shadow-sm ring-1 ring-inset ring-gray-300 
                   placeholder:text-gray-400 focus:ring-2 focus:ring-inset 
                   focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
          {errors.contactPerson && (
            <span className="text-sm text-red-500 leading-0">
              {errors.contactPerson}
            </span>
          )}
        </div>

        <div className="flex-1">
          <label className="block text-sm font-medium leading-6 text-gray-900">
            GST No.
          </label>
          <div className="mt-1">
            <input
              type="text"
              value={supplier.gst}
              onChange={(e) =>
                setSupplier({ ...supplier, gst: e.target.value })
              }
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 
                   shadow-sm ring-1 ring-inset ring-gray-300 
                   placeholder:text-gray-400 focus:ring-2 focus:ring-inset 
                   focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
      </div>

      <div className="flex gap-4 pt-2">
        <div className="flex-1">
          <label className="block text-sm font-medium leading-6 text-gray-900">
            Phone
          </label>
          <div className="mt-1">
            <input
              type="text"
              value={supplier.phone}
              maxLength={10}
              onChange={(e) => {
                const val = e.target.value.replace(/\D/g, "");
                setSupplier({ ...supplier, phone: val });
              }}
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 
                   shadow-sm ring-1 ring-inset ring-gray-300 
                   placeholder:text-gray-400 focus:ring-2 focus:ring-inset 
                   focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
          {errors.phone && (
            <span className="text-sm text-red-500 leading-0">
              {errors.phone}
            </span>
          )}
        </div>

        <div className="flex-1">
          <label className="block text-sm font-medium leading-6 text-gray-900">
            Email
          </label>
          <div className="mt-1">
            <input
              type="email"
              value={supplier.email}
              onChange={(e) =>
                setSupplier({ ...supplier, email: e.target.value })
              }
              className="block w-full rounded-md border-0 py-1.5 text-gray-900 
                   shadow-sm ring-1 ring-inset ring-gray-300 
                   placeholder:text-gray-400 focus:ring-2 focus:ring-inset 
                   focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
      </div>

      <div className="pt-2">
        <label className="block text-sm font-medium leading-6 text-gray-900"> 
        Address
        </label>
        <div className="mt-1">
          <input
            type="text"
            value={supplier.address}
            onChange={(e) =>
              setSupplier({ ...supplier, address: e.target.value })
            }
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 
                       shadow-sm ring-1 ring-inset ring-gray-300 
                       placeholder:text-gray-400 focus:ring-2 focus:ring-inset 
                       focus:ring-indigo-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div>

      <div className="flex gap-4 mt-4">
        <button
          onClick={onSave}
          type="button"
          disabled={loading}
          className="px-3 py-2 bg-primary hover:bg-hover text-white rounded disabled:opacity-50"
        >
          {loading ? (isEditMode ? "Updating..." : "Saving...") : isEditMode ? "Update" : "Save"}
        </button>

        <button 
        onClick={closeModal} 
        type="button"
        className="text-sm font-semibold leading-6 text-gray-900">
          Cancel
        </button>
      </div>
    </div>
  );
};

export default AddSupplier;
